import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';

@Component({
    selector: 'app-onboarding-card',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './onboarding-card.component.html',
    styleUrl: './onboarding-card.component.scss'
})
export class OnboardingCardComponent {
    private router = inject(Router);
    currentStep = 0;
    totalSteps = 3;

    // Step content data
    steps = [
        {
            title: 'Welcome to the Future of Poultry Farming',
            description: [
                'Enter a fully AI-driven poultry ecosystem designed for the next generation of farming.',
                'From space-efficient design to intelligent automation, the Smart Poultry System transforms every aspect of farm management — minimizing labor, maximizing yield, and ensuring bird health.'
            ]
        },
        {
            title: 'Real-Time Intelligence at Your Fingertips',
            description: [
                'Access a live 360° view of your farm — from temperature and humidity to flock health, mortality alerts, and feeding behavior — all updated in real time through IoT and AI integration.',
                'Visual dashboards, floating AI cards, and ambient alerts provide you with proactive control and precision.'
            ]
        },
        {
            title: 'Smart Control. Zero Guesswork.',
            description: [
                'Manage complex operations with ease:',
                '•Automated feeding & watering',
                '•Environmental control (CO₂, humidity, ventilation)',
                '•Vaccine & medication scheduling',
                '•Staff & inventory management'
            ]
        }
    ];

    onPrevious() {
        if (this.currentStep > 0) {
            this.currentStep--;
        }
    }

    onNext() {
        if (this.currentStep < this.totalSteps - 1) {
            this.currentStep++;
        } else {
            this.router.navigate(['/register']);
        }
    }

    getSteps() {
        return Array(this.totalSteps).fill(0);
    }

    getCurrentStep() {
        return this.steps[this.currentStep];
    }
}
